export interface ICancelProductRequest {

    LicenseKey: string;
    CancellationReason: string;
    CancellationComments: string;
    AdminID: number;

}

export class CancelProductRequest implements ICancelProductRequest {

    LicenseKey: string;
    CancellationReason: string;
    CancellationComments: string;
    AdminID: number;

}
